import { ActivitiesAnalyticalPerTask } from 'presentation/app/modules/Reports/pages/activities/analyticals/activities-analytical-per-task';

export const MakeActivitiesAnalyticalPerTask = () => {
  return <ActivitiesAnalyticalPerTask />;
};
